import { Children, isValidElement, ReactNode } from 'react';

export function getChildrenByType(children: ReactNode | ReactNode[], type: unknown): ReactNode[] {
    return Children.toArray(children).filter((child) => isValidElement(child) && child.type === type);
}

export function getChildrenProps<T>(children: ReactNode | ReactNode[]): T[] {
    const props: T[] = [];
    Children.forEach(children, (child) => {
        if (isValidElement(child)) {
            props.push(child.props);
        }
    });
    return props;
}
